import React from 'react';
import { connect } from 'react-redux';
import './StatsScreen.scss'

import { withRouter } from 'react-router-dom' 
import { Fire, Time, Tools } from '../../../services'

import { Headerbar, Loader, TabsContainer, PeriodChart } from '../../Reusable'
import { updateUser } from '../../../actions/auth.action'

import { Button } from 'reactstrap'

import { Chart } from 'react-charts'

import FadeIn from 'react-fade-in';

const tabs = [
  {
    title: 'Utilisateurs',
    key: 'users',
  },
  {
    title: 'Annonces',
    key: 'ads',
  },
  {
    title: 'Commandes',
    key: 'orders',
  },
  {
    title: 'Export',
    key: 'export',
  }
]

interface Props {
  match: any;
  history: any;
}
const StatsScreen: React.FC<Props> = (props) => {

  const history = props.history
  const tab = props.match.params.tab || 'users'
  const [generic, setGeneric] = React.useState<any>({})
  const [assos, setAssos] = React.useState<any[]>([])
  const [adsMakers, setAdsMakers] = React.useState<any[]>([])
  const [users, setUsers] = React.useState<any[]>([])
  const [loading, setLoading] = React.useState(false)
  const [loadingExport, setLoadingExport] = React.useState(false)

  const fetchGeneric = React.useCallback(async () => {
    setLoading(true)
    try {
      const genericRef = Fire.collection('stats').doc('generic')
      const generic = await Fire.doc(genericRef)
      setGeneric(generic)
    } catch (err) {
      console.warn(err)
    }
    setLoading(false)
  }, [])

  React.useEffect(() =>  {
    fetchGeneric()
  }, [])

  React.useEffect(() => {
    if (users.length === 0 && tab === 'export')
      fetchExportData()
  }, [tab])

  const fetchExportData = async () => {
    setLoadingExport(true)
    try {
      const users = await Fire.list(Fire.collection('users'))
      setUsers(users)

      const assos = await Fire.list(Fire.collection('pros').where('type', '==', 'asso'))
      setAssos(assos)

      const adsMakers = await Fire.list(Fire.collection('pros').where('type', '!=', 'asso'))
      setAdsMakers(adsMakers)
    } catch (err) {
      console.warn(err)
    }
    setLoadingExport(false)
  }

  const getBetween = async (ref: any, dateStart: any, dateEnd: any) => {
    try {
      const betweenRef = ref
        .where('createdAt', '>=', dateStart)
        .where('createdAt', '<=', dateEnd)
      const list = await Fire.list(betweenRef)
      return list
    } catch (err) {
      console.warn(err)
    }
    return []
  }

  const getUsers = async (dateStart: any, dateEnd: any) => {
    const usersRef = Fire.collection('users')
    return await getBetween(usersRef, dateStart, dateEnd)
  }

  const getImpressions = async (dateStart: any, dateEnd: any) => {
    const usersRef = Fire.collection('stats').doc('generic').collection('total_impressions_full_list')
    return await getBetween(usersRef, dateStart, dateEnd)
  }

  const getReach = async (dateStart: any, dateEnd: any) => {
    const usersRef = Fire.collection('stats').doc('generic').collection('total_impressions_unique_list')
    return await getBetween(usersRef, dateStart, dateEnd)
  }

  const getFavorites = async (dateStart: any, dateEnd: any) => {
    const usersRef = Fire.collection('stats').doc('generic').collection('total_favorites_full_list')
    return await getBetween(usersRef, dateStart, dateEnd)
  }

  const getShares = async (dateStart: any, dateEnd: any) => {
    const usersRef = Fire.collection('stats').doc('generic').collection('total_shares_full_list')
    return await getBetween(usersRef, dateStart, dateEnd)
  }

  const getOrders = async (dateStart: any, dateEnd: any) => {
    const ordersRef = Fire.collection('orders')
    return await getBetween(ordersRef, dateStart, dateEnd)
  }

  const renderContent = () => {
    if (tab === 'orders') {
      return renderOrders()
    }
    if (tab === 'ads') {
      return renderAds()
    }
    if (tab === 'export') {
      return renderExport()
    }
    return renderUsers()
  }

  const exportAssos = async () => {
    const columns = [
      {
        name: "Nom de l'asso",
        format: (item: any) => item.name || '',
      },
      {
        name: "Email",
        format: (item: any) => item.email || '-',
      },
      {
        name: "Date de création",
        format: (item: any) => item.createdAt ? Time.renderDate(item.createdAt) : '-',
      },
    ]
    const csv = Tools.rowsToCSV(columns, assos)
    Tools.downloadFile('assos.csv', csv)
  }

  const exportAdsMakers = async () => {
    const columns = [
      {
        name: "Nom de l'asso",
        format: (item: any) => item.name || '',
      },
      {
        name: "Email",
        format: (item: any) => item.email || '-',
      },
      {
        name: "Date de création",
        format: (item: any) => item.createdAt ? Time.renderDate(item.createdAt) : '-',
      },
    ]
    const csv = Tools.rowsToCSV(columns, adsMakers)
    Tools.downloadFile('annonceurs.csv', csv)
  }

  const exportUsers = async () => {
    const columns = [
      {
        name: "Prénom",
        format: (item: any) => item.first_name || '-',
      },
      {
        name: "Nom",
        format: (item: any) => item.last_name || '-',
      },
      {
        name: "Email",
        format: (item: any) => item.email || '-',
      },
      {
        name: "Date de création",
        format: (item: any) => item.createdAt ? Time.renderDate(item.createdAt) : '-',
      },
    ]
    const csv = Tools.rowsToCSV(columns, users)
    Tools.downloadFile('users.csv', csv)
  }

  const renderExport = () => {

    if (loadingExport)
      return (<Loader />)

    return (
      <div className="row">
        <div className="col-lg-3 col-6">
          <div className="small-box">
            <div className="inner">
              <h3>{users.length || 0}</h3>
              <p>Nb. Users</p>
              <Button className="bg-primary" onClick={exportUsers}>Export</Button>
            </div>
            <div className="icon">
              <i className="fas fa-shopping-cart"></i>
            </div>
          </div>
        </div>

        <div className="col-lg-3 col-6">
          <div className="small-box">
            <div className="inner">
              <h3>{assos.length || 0}</h3>
              <p>Nb. Assos</p>
              <Button className="bg-primary" onClick={exportAssos}>Export</Button>
            </div>
            <div className="icon">
              <i className="fas fa-shopping-cart"></i>
            </div>
          </div>
        </div>

        <div className="col-lg-3 col-6">
          <div className="small-box">
            <div className="inner">
              <h3>{adsMakers.length || 0}</h3>
              <p>Nb. Annonceurs</p>
              <Button className="bg-primary" onClick={exportAdsMakers}>Export</Button>
            </div>
            <div className="icon">
              <i className="fas fa-shopping-cart"></i>
            </div>
          </div>
        </div>

      </div>
    )
  }

  const renderUsers = () => {
    return (
      <React.Fragment>
        { loading ? (
          <Loader />
        ) : (
          <div className="row">
            <div className="col-lg-3 col-6">
              <div className="small-box bg-warning">
                <div className="inner">
                  <h3>{generic.users_count || 0}</h3>
                  <p>Nb. Users</p>
                </div>
                <div className="icon">
                  <i className="fas fa-shopping-cart"></i>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-6">
              <div className="small-box bg-info">
                <div className="inner">
                  <h3>{generic.ios_count || 0}</h3>
                  <p>iOS Users</p>
                </div>
                <div className="icon">
                  <i className="fas fa-shopping-cart"></i>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-6">
              <div className="small-box bg-info">
                <div className="inner">
                  <h3>{generic.android_count || 0}</h3>
                  <p>Android Users</p>
                </div>
                <div className="icon">
                  <i className="fas fa-shopping-cart"></i>
                </div>
              </div>
            </div>
          </div>
        )}

        <PeriodChart
          title='Nouvelles inscriptions'
          getData={getUsers}
          getDate={(item: any) => Fire.getDateFor(item.createdAt)}
          />
      </React.Fragment>
    )
  }

  const renderAds = () => {
    return (
      <React.Fragment>
        { loading ? (
          <Loader />
        ) : (
          <div className="row">
            <div className="col-lg-4 col-6">
              <div className="small-box bg-warning">
                <div className="inner">
                  <h3>{generic.ads_count || 0}</h3>
                  <p>Nb. Annonces</p>
                </div>
                <div className="icon">
                  <i className="fas fa-shopping-cart"></i>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-6">
              <div className="small-box bg-info">
                <div className="inner">
                  <h3>{generic.events_count || 0}</h3>
                  <p>Evènements</p>
                </div>
                <div className="icon">
                  <i className="fas fa-shopping-cart"></i>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-6">
              <div className="small-box bg-info">
                <div className="inner">
                  <h3>{generic.discounts_count || 0}</h3>
                  <p>Bons plans</p>
                </div>
                <div className="icon">
                  <i className="fas fa-shopping-cart"></i>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-6">
              <div className="small-box bg-info">
                <div className="inner">
                  <h3>{generic.places_count || 0}</h3>
                  <p>Points de vente</p>
                </div>
                <div className="icon">
                  <i className="fas fa-shopping-cart"></i>
                </div>
              </div>
            </div>
          </div>
        )}

        <PeriodChart
          title='Impressions'
          getData={getImpressions}
          getDate={(item: any) => Fire.getDateFor(item.createdAt)}
          />

        <PeriodChart
          title='Reach'
          getData={getReach}
          getDate={(item: any) => Fire.getDateFor(item.createdAt)}
          />

        <PeriodChart
          title='Favoris'
          getData={getFavorites}
          getDate={(item: any) => Fire.getDateFor(item.createdAt)}
          />

        <PeriodChart
          title='Partages'
          getData={getShares}
          getDate={(item: any) => Fire.getDateFor(item.createdAt)}
          />
      </React.Fragment>
    )
  }

  const renderOrders = () => {
    return (
      <React.Fragment>
        { loading ? (
          <Loader />
        ) : (
          <div className="row">
            <div className="col-lg-3 col-6">
              <div className="small-box bg-warning">
                <div className="inner">
                  <h3>{generic.orders_count || 0}</h3>
                  <p>Nb. Commandes</p>
                </div>
                <div className="icon">
                  <i className="fas fa-shopping-cart"></i>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-6">
              <div className="small-box bg-info">
                <div className="inner">
                  <h3>{Tools.renderPrice(generic.total_orders_amount || 0)}</h3>
                  <p>Volume d'affaire</p>
                </div>
                <div className="icon">
                  <i className="fas fa-shopping-cart"></i>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-6">
              <div className="small-box bg-info">
                <div className="inner">
                  <h3>{Tools.renderPrice(generic.total_popout_amount || 0)}</h3>
                  <p>Chiffre d'affaire</p>
                </div>
                <div className="icon">
                  <i className="fas fa-shopping-cart"></i>
                </div>
              </div>
            </div>
          </div>
        )}

        <PeriodChart
          title='Commandes'
          getData={getOrders}
          getDate={(item: any) => Fire.getDateFor(item.createdAt)}
          />
        <PeriodChart
          title='Revenus'
          getData={getOrders}
          getNumber={(item: any) => item.total || 0}
          getDate={(item: any) => Fire.getDateFor(item.createdAt)}
          />
      </React.Fragment>
    )
  }

  return (
    <div className="wrapper">
      <Headerbar
        title="Statistiques Pop Out"
        />
      <div className="content-wrapper">
        <div className="content stats">
          <div className="container-fluid">

            <TabsContainer
              tab={tab}
              tabs={tabs}
              onSelect={(tab) => history.push('/admin/stats/' + tab.key)}
              />

            <FadeIn key={'fade-' + tab}>
              {renderContent()}
            </FadeIn>
            
          </div>
        </div>
      </div>
    </div>
  );
}

export default withRouter(StatsScreen)
